module.exports = __webpack_public_path__ + "static/img/desk.2ec802d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/he/desk.png
// module id = DjuV
// module chunks = 1